// ========================================
// HTTP CONFIGURATION
// Centralized configuration for HTTP client behavior
// ========================================

/**
 * HTTP Client Configuration
 * These values can be overridden via environment variables
 */
export const HTTP_CONFIG = {
  // Request timeout in milliseconds (default: 12 seconds)
  DEFAULT_TIMEOUT_MS: parseInt(process.env.REACT_APP_HTTP_TIMEOUT_MS, 10) || 12000,
  
  // Retry configuration for GET requests
  RETRY: {
    // Maximum number of retry attempts
    MAX_ATTEMPTS: 3,
    // Base delay in milliseconds (doubles each attempt: 250, 500, 1000)
    BASE_DELAY_MS: 250,
    // Maximum delay between retries
    MAX_DELAY_MS: 2000,
    // HTTP status codes that should trigger a retry
    RETRYABLE_STATUS_CODES: [408, 429, 500, 502, 503, 504],
    // Only retry idempotent methods
    RETRYABLE_METHODS: ['GET', 'HEAD', 'OPTIONS'],
  },
  
  // Rate limiting configuration
  RATE_LIMIT: {
    // Debounce delay for search inputs (ms)
    SEARCH_DEBOUNCE_MS: 400,
    // Throttle delay for form submissions (ms)
    SUBMIT_THROTTLE_MS: 2000,
  },
};

/**
 * Error codes for HTTP errors
 */
export const HTTP_ERROR_CODES = {
  TIMEOUT: 'TIMEOUT',
  NETWORK_ERROR: 'NETWORK_ERROR',
  ABORTED: 'ABORTED',
  UNAUTHORIZED: 'UNAUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  RATE_LIMITED: 'RATE_LIMITED',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  SERVER_ERROR: 'SERVER_ERROR',
  CSRF_MISMATCH: 'CSRF_MISMATCH',
  UNKNOWN: 'UNKNOWN',
};

/**
 * Maps HTTP status codes to error codes
 */
export function getErrorCodeFromStatus(status) {
  if (status === 401) return HTTP_ERROR_CODES.UNAUTHORIZED;
  if (status === 403) return HTTP_ERROR_CODES.FORBIDDEN;
  if (status === 404) return HTTP_ERROR_CODES.NOT_FOUND;
  if (status === 408) return HTTP_ERROR_CODES.TIMEOUT;
  if (status === 422) return HTTP_ERROR_CODES.VALIDATION_ERROR;
  if (status === 429) return HTTP_ERROR_CODES.RATE_LIMITED;
  if (status >= 500) return HTTP_ERROR_CODES.SERVER_ERROR;
  return HTTP_ERROR_CODES.UNKNOWN;
}

/**
 * User-friendly error messages
 */
export const ERROR_MESSAGES = {
  [HTTP_ERROR_CODES.TIMEOUT]: 'Request timed out. Please check your connection and try again.',
  [HTTP_ERROR_CODES.NETWORK_ERROR]: 'Network error. Please check your internet connection.',
  [HTTP_ERROR_CODES.ABORTED]: 'Request was cancelled.',
  [HTTP_ERROR_CODES.UNAUTHORIZED]: 'Your session has expired. Please log in again.',
  [HTTP_ERROR_CODES.FORBIDDEN]: 'You do not have permission to perform this action.',
  [HTTP_ERROR_CODES.NOT_FOUND]: 'The requested resource was not found.',
  [HTTP_ERROR_CODES.RATE_LIMITED]: 'Too many requests. Please wait a moment and try again.',
  [HTTP_ERROR_CODES.VALIDATION_ERROR]: 'Invalid data submitted. Please check your input.',
  [HTTP_ERROR_CODES.SERVER_ERROR]: 'Server error. Please try again later.',
  [HTTP_ERROR_CODES.CSRF_MISMATCH]: 'Security token mismatch. Please refresh the page.',
  [HTTP_ERROR_CODES.UNKNOWN]: 'An unexpected error occurred. Please try again.',
};
